/* eslint-disable yoda */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { StatusPill } from '@ps-design-system/components/StatusPill';
import QuestionIcon from '@ps-design-system/icons/Question/Question16';
import {
  TooltipArrow,
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@ps-design-system/components/Tooltip';

import { LISTING_STATUSES } from '../constants/status.const';

const ListingStatus = ({ status }) => {
  const config = LISTING_STATUSES[status];

  if (!status || !config) {
    return null;
  }

  const { color, message } = config;

  if (status === 'PAUSED_INTERNALLY') {
    return (
      <Tooltip>
        <TooltipTrigger>
          <StatusPill size="md" variant={color} suffix={<QuestionIcon />}>
            <FormattedMessage id={message?.id} defaultMessage={message?.defaultMessage} />
          </StatusPill>
        </TooltipTrigger>
        <TooltipContent className="status-pill" side="bottom">
          <FormattedMessage id="pause.status.peerspace_has_paused" defaultMessage="Peerspace has paused your listing due to falling below host community standards." />
          {' '}
          <a className='link' href="https://support.peerspace.com/en/articles/13047194-why-was-my-peerspace-listing-paused" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="pause.status.learn_more" defaultMessage="Learn more about host performance metrics." />
          </a>
          <TooltipArrow className="tw-fill-base-white" />
        </TooltipContent>
      </Tooltip>
    );
  }

  if (status === 'DRAFT') {
    return (
      <Tooltip>
        <TooltipTrigger>
          <StatusPill size="md" variant={color} suffix={<QuestionIcon />}>
            <FormattedMessage id={message?.id} defaultMessage={message?.defaultMessage} />
          </StatusPill>
        </TooltipTrigger>
        <TooltipContent className="status-pill" side="bottom">
          <FormattedMessage id="pause.status.peerspace_has_deactivated" defaultMessage="For more information, please visit our Support Center." />
          {' '}
          <a className='link' href="https://support.peerspace.com/en/articles/12407624-why-was-my-peerspace-listing-deactivated" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="uploader.three_d_tour_modal.description_link" defaultMessage="Learn more" />
          </a>
          <TooltipArrow className="tw-fill-base-white" />
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <StatusPill size="md" variant={color}>
      <FormattedMessage id={message?.id} defaultMessage={message?.defaultMessage} />
    </StatusPill>
  );
};

ListingStatus.propTypes = {
  status: PropTypes.string
};

ListingStatus.defaultProps = {
  status: ''
};

export default ListingStatus;
